import { Component, Renderer, ChangeDetectorRef } from "@angular/core";
import { NavController, NavParams, Events, ToastController, ActionSheetController, PopoverController, App, Platform, LoadingController } from "ionic-angular";
import { Users } from "../../models/users";
import { PopOverOptionComponent } from "../../components/pop-over-option/pop-over-option";
import { LoginPage } from "../login/login";
import { Imybook, ImyDownloadBooks } from "../../models/mybook";
import { FirebaseService } from "../../services/firebase.service";
import { Observable } from "rxjs";
import { AuthService } from "../../services/auth.service";
import { BookPage } from "../BOOK-READER/book/book";

import { MybookDetailPage } from "../mybook-detail/mybook-detail";
//import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
//import { File } from '@ionic-native/file';

@Component({
  selector: "page-books-local",
  templateUrl: "books-local.html"
})
export class BooksLocalPage {
  loadingHome: any;

  MyBooks: Imybook[]; //insieme dei miei libri potenzialmente filtrati
  allMybooks: Imybook[]; //insieme competo dei miei libri
  UserDowloadBooks: ImyDownloadBooks[]; //insieme dei libri con file in locale

  directoryInDevice: string = '';

  BookOnRead: Imybook; // Libro in fase di lettura

  bookLocalCount = 0; // Numero di libri presnti nella propria libreria
  SubType = "";
  endSubDate = "";

  userData: Users; //Informazioni dell'utente loggato

  textsrc: string = ""; //Variabile testo da ricercare
  Online: boolean = true; // Verifica se si è online

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    public toastCtrl: ToastController,
    public actionSheetCtrl: ActionSheetController,
    public popoverCtrl: PopoverController,
    public appCtrl: App,
    private FireSrvc: FirebaseService,
    private AuthSrvc: AuthService,
    public platform: Platform,
    //private file: File,
    //private transfer: FileTransfer,
    private loadinCtrl: LoadingController,
    private renderer: Renderer,
    private ref: ChangeDetectorRef
  ) {
    this.bookLocalCount = 0;

    // Imposta la directory locale in base al dispositivo
    this.platform.ready().then((readySource) => {

      //Recupera il parametro dalla login per sapere se è offline
      this.Online = navParams.get("Online");

console.log(this.platform);

      this.ref.detectChanges();
      if (readySource == 'cordova') {
        if (this.platform.is('ios')) {
        //  this.directoryInDevice = this.file.documentsDirectory //.replace(/file:\/\//g, '');
        } else
          if (this.platform.is('android')) {
          //  this.directoryInDevice = this.file.externalDataDirectory //.replace(/file:\/\//g, '');
          }
      }
      this._InitEvents();
    });


  }

  _InitEvents() {
    //Sottoscrive un evento di successo
    this.events.subscribe("mybook:POST-OK", msg => {
      // this.sendNotification(msg);
      console.log("evento libro");
      this.textsrc = "";
      this.filterBook("");
      // this.refreshMyBook();
    });

    //Sottoscrive un evento di errore
    this.events.subscribe("mybook:POST-ERROR", msg => {
      this.sendNotification(msg);
      console.error("ERROR: " + msg);
      this.textsrc = "";
      this.filterBook("");
      this.refreshMyBook();
    });

    //Sottoscrive un evento di uscita dal Lettore
    this.events.subscribe("mybook:ExitRead", msg => {
      console.log("evento chiusura libro");
      this.UpdateMyBook(this.BookOnRead);
      // this.refreshMyBook();
    });

    this.events.subscribe("network:online", msg => {
      console.log('evento online');
      this.Online = true;
      this.ref.detectChanges();
    });

    this.events.subscribe("network:offline", msg => {
      console.log('evento offline');
      this.Online = false;
      this.ref.detectChanges();
    });

  }

  ionViewDidLoad() {
    //Carica i dati dell'utente e i libri nella proprio libreria
    if (localStorage.getItem("UserDataLocal")) {
      //Carica le info dell'utente
      this.userData = JSON.parse(localStorage.getItem("UserDataLocal"));
      // this.sendNotification("Benvenuto " + this.userData.email);
      this.SubType = this.userData.period;
      this.endSubDate = this.userData.renewal_date;
      //carica i dati
      this.refreshMyBook();
      // console.log(this.SubType)
    }
  }

  /**
   * Aggiorna la data di ultima lettura
   * @param BooksRead
   */
  UpdateMyBook(BooksRead: Imybook) {

    // BooksRead.last_view_date = new Date().toISOString();
    this.FireSrvc.UpdateMyBook(BooksRead).then(res => {
      // console.log(this.BookOnRead);
      // this.BookOnRead = undefined;
    });

  }

  //aggiorna la lista rieseguendo la chiamata GET al webService
  refreshMyBook() {

    try {


      this.FireSrvc.getMybook().subscribe(
        (resmy: [Imybook]) => {
          this.Online = true;
          this.MyBooks = resmy;
          this.bookLocalCount = this.MyBooks.length;
         // console.log(this.bookLocalCount);
          this.allMybooks = this.MyBooks.slice();
          this.ref.detectChanges();
        },
        err => {
          Observable.throw(err);
          this.Online = false;
          console.log(err);
        }
      );

      //Se è offline prova a caricare dalla local storage
      if (!this.Online) {
        if (localStorage.getItem("mybooks")) {
          this.MyBooks = JSON.parse(localStorage.getItem("mybooks"));
          this.allMybooks = this.MyBooks.slice();
        }
      }

    } catch (error) {
      console.error(error);
    }

  }

   //Apre la schermata di dettaglio del libro selezionato
   showBookDetail2(book) {
    let isPresent: boolean = false;
    isPresent = true;
    let id: string = this.userData.id;

    new Promise((resolve, reject) => {
      this.navCtrl.push(MybookDetailPage, {
             book: book,
      iduser: id,
      present: isPresent,
      callback: resolve
      });
  }).then((data) => {
    console.log(data); // 'some data'

    if (data == 'readbook:ok') {
           this.read(book);
          } else if (data == 'removebook:ok') {
            this.removemybook(book);
          }
          this.textsrc = '';
          this.filterBook('');
  });
}

  /*************************************  RIMOZIONE LIBRO DALLA LIBRERIA ***************************/

  //Intercetta l'evento di pressione prolungata su un libro per eliminarlo
  pressEvent(e, book: Imybook) {
    if (this.Online) {
      this.presentActionSheet(book);
      //  console.log("long-press id" + book.id);
    } else {
      this.sendNotification("Impossibile modificare la libreria quando si è offline");
    }
  }

  //Chiama l'ActionSheet che chiede la conferma dell'eliminazione
  presentActionSheet(book: Imybook) {
    let actionSheet = this.actionSheetCtrl.create({
      title: "Rimuovere dalla libreria?",
      buttons: [
        {
          text: "Rimuovi",
          role: "destructive",
          handler: () => {
            //this.PresentLoading();
            console.log("delete clicked");
            this.removemybook(book);
          }
        },
        {
          text: "Annulla",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          }
        }
      ]
    });
    actionSheet.present();
  }

  //rimuove il libro dalla libreria
  removemybook(book: Imybook) {
    this.FireSrvc.RemoveMyBook(book);

    //Carica i dati dell'utente e i libri nella proprio libreria locali
    if (localStorage.getItem("UserDowloadBooks")) {

      //Carica le info dei libri locali
      this.UserDowloadBooks = JSON.parse(localStorage.getItem("UserDowloadBooks"));

      // Cerco l'elemento da aggiornare
      const IndexReplace = this.UserDowloadBooks.findIndex(res => res.id === book.id);

      console.log(IndexReplace);

      if (IndexReplace != -1) {

        // rimuove l'oggetto dall'array
        this.UserDowloadBooks.splice(IndexReplace, 1)

        //Salvo nella localStorage
        localStorage.setItem("UserDowloadBooks", JSON.stringify(this.UserDowloadBooks));

      };
    };

    // console.log(res);
    this.sendNotification("Libro rimosso");
  }

  /*************************************  GESTIONE EVENTI INTERFACCIA ***************************/


  GotoOnlineLibrary() {

    this.navCtrl.parent.select(1);

  }


  async read(myb: Imybook) {

    let UserLocalBook: ImyDownloadBooks;

    // Cerco dal locale quel è il libro da caricare in locale
    if (localStorage.getItem("UserDowloadBooks")) {
      this.UserDowloadBooks = JSON.parse(localStorage.getItem("UserDowloadBooks"));

      // Cerco l'elemento da leggere
      UserLocalBook = this.UserDowloadBooks.find(item => item.id === myb.id)
      console.log('trovato libro')
    }

    // Carico il file dal locale
    if (UserLocalBook === undefined || UserLocalBook.status !== 'offline') {
      this.PresentLoading();
   //   await this.downloadBook(myb);
      this.loadingHome.dismiss();
    }

    this.BookOnRead = myb;
    // console.log("show", myb);
    this.navCtrl.push(BookPage, { book: myb });
    // this.navCtrl.setRoot(BookPage, {
    //   book: myb
    // });
  }

  //mostra il popup di caricamento
  PresentLoading() {
    this.loadingHome = this.loadinCtrl.create({
      spinner: "ios",
      content: "Download ePub..."
      // dismissOnPageChange: true
    });

    this.loadingHome.present();
  }

  //Evento chiamato dall'utente con il pull-down della pagina
  doRefresh(refresher) {
    this.FireSrvc.getMybook().subscribe(
      (resmy: [Imybook]) => {
        this.MyBooks = resmy;
        this.allMybooks = this.MyBooks.slice();

        this.filterBook(this.textsrc);
      },
      err => {
        Observable.throw(err);
        this.Online = false;
        console.log(err);
      }
    );

    refresher.complete();
  }

  //Gestisce il menù in alto a destra
  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(PopOverOptionComponent);
    popover.present({
      ev: myEvent
    });
    popover.onDidDismiss(popoverData => {
      // console.log(popoverData);
      if (popoverData == "logout") {
        this.logout();
      }
    });
  }

  //Mostra un messaggio utente
  sendNotification(message: string) {
    let notification = this.toastCtrl.create({
      message: message,
      duration: 2000
    });
    notification.present();
  }

  //Esegue il LogOut
  logout() {
    //Salvo nella local storage i dati dell'utente
    this.userData.autologin = false;
    localStorage.setItem("UserDataLocal", JSON.stringify(this.userData));
    this.AuthSrvc.doLogout()
      .then(() => {
        this.appCtrl.getRootNav().setRoot(LoginPage);
      })
      .catch(error => {
        console.error(error);
      });
  }

  /*************************************  GESTIONE RICERCA ***************************/

  //evento di ricerca nella barra
  onInput(e) {
    // this.events.publish('book-searched',this.textsrc)
    // console.log(e.target.value);
    this.filterBook(this.textsrc);
    this.renderer.invokeElementMethod(e.target, 'blur');
  }

  //svuotamento della ricerca
  onCancel(e) {
    //  this.events.publish('book-searched',this.textsrc)
    // console.log(e.target.value);
    this.filterBook(this.textsrc);
  }

  //Filtra l'array dei libri
  filterBook(textsrc: string) {
    if (textsrc.length === 0) {
      this.MyBooks = this.allMybooks;
    }
    this.MyBooks = this.allMybooks;
    // console.log(this.MyBooks);

    // this.MyBooks = this.MyBooks.filter(book => book.title.toLowerCase().includes(textsrc.toLowerCase()));

    this.MyBooks = this.MyBooks.filter(function (item) {
      return (item.title.toString().toLowerCase().includes(textsrc.toLowerCase()) ||
        item.autor.toLowerCase().includes(textsrc.toLowerCase()));
    });

  }

  /************************************* DOWNLOAD EPUB\COVER ***************************/
  /*
  async downloadBook(book: Imybook) {



    await this.transferInDevice(book, book.ePubUrl, book.id + '.epub')


  }



  async transferInDevice(book, url, fileName: string) {


    try {


    const fileTransfer: FileTransferObject = this.transfer.create();

    await fileTransfer.download(url, this.directoryInDevice + fileName, true).then(
      entry => {
        console.log("download complete: " + normalizeURL(entry.toURL()));
        this.platform
          .ready()
          .then(() => {
            return this.file.resolveDirectoryUrl(this.directoryInDevice);
          })
          .then(rootDir => {
            return this.file.getFile(rootDir, fileName, { create: false });
          })
          .then(fileEntry => {
            fileEntry.file(file => {

              // console.log(file)
              if (this.platform.is("ios")) {
                console.log(fileEntry.nativeURL);
                // alert(fileEntry.nativeURL);
                // book.ePubLocal = fileEntry.nativeURL;
                book.ePubLocal = String(fileEntry.nativeURL) // this.directoryInDevice + ePubFileName;
                book.status = "offline";
                this.UpdateLocalBooks(book);
                return fileEntry.nativeURL;
              } else {
                console.log(fileEntry.nativeURL);
                // book.ePubLocal = fileEntry.nativeURL;
                book.ePubLocal = String(fileEntry.nativeURL) // this.directoryInDevice + ePubFileName;
                book.status = "offline";
                this.UpdateLocalBooks(book);
                return fileEntry.nativeURL;
              }

            });


          });
      },
      error => {
        // handle error
        console.error(error);
      }
    );

    } catch (error) {
      console.error(error);
    }
  }
*/
  async UpdateLocalBooks(book: Imybook) {

    let MyBookLocal: ImyDownloadBooks = {
      id: book.id,
      status: 'Online',
      ePubLocal: '',
      imgLocal: ''
    };

    //Carica i dati dell'utente e i libri nella proprio libreria locali
    if (localStorage.getItem("UserDowloadBooks")) {

      //Carica le info dei libri locali
      this.UserDowloadBooks = JSON.parse(localStorage.getItem("UserDowloadBooks"));

      // Cerco l'elemento da aggiornare
      const IndexReplace = this.UserDowloadBooks.findIndex(res => res.id === MyBookLocal.id);

      // console.log(IndexReplace);

      if (IndexReplace != -1) {

        //Aggiorna l'elemento nell'array come offline
        MyBookLocal.id = book.id;
        MyBookLocal.status = book.status;
        MyBookLocal.ePubLocal = book.ePubLocal;
        MyBookLocal.imgLocal = book.imgLocal;

        this.UserDowloadBooks[IndexReplace] = MyBookLocal;

        // console.log(MyBookLocal);

        //Salvo nella localStorage
        localStorage.setItem("UserDowloadBooks", JSON.stringify(this.UserDowloadBooks));

      };
    } else {

      // apertura da un alltro dispositivo
      MyBookLocal.id = book.id;
      MyBookLocal.status = book.status;
      MyBookLocal.ePubLocal = book.ePubLocal;
      MyBookLocal.imgLocal = book.imgLocal;

      this.UserDowloadBooks = [MyBookLocal]

      //Salvo nella localStorage
      localStorage.setItem("UserDowloadBooks", JSON.stringify(this.UserDowloadBooks));

    };
  }

}



// WEBPACK FOOTER //
// ./src/pages/books-local/books-local.ts